export const imageSize = (url: string, size: number) => {
  if(url.startsWith('blob:') || !url.startsWith('https://cdn-')) return url;
  var imgArr = url.split('/');
  imgArr[imgArr.length - 1] = size + '/' + imgArr[imgArr.length - 1];
  var imgURL = imgArr.join('/');
  return imgURL;
};
